import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountModel } from 'src/app/_interfaces';
import { AccountService, AppStringsService } from 'src/app/_services';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-app-only',
    templateUrl: './app-only.component.html',
    styleUrls: ['./app-only.component.scss'],
    imports: [MatIconButton, MatIcon]
})
export class AppOnlyComponent implements OnInit {
    public account: AccountModel | null = null

    constructor(
        private dialogRef: MatDialogRef<AppOnlyComponent>,
        public appStringAPI: AppStringsService,
        public accountService: AccountService,
        @Inject(MAT_DIALOG_DATA) public data: string
    ) {
    }

    get iosAppUrl(): string {
        return this.account?.ios_app_version_url ?? ''
    }

    get androidAppUrl(): string {
        return this.account?.android_app_version_url ?? ''
    }

    ngOnInit(): void {
        this.accountService.account.subscribe((account) => { if (account?.id) this.account = account })
    }

    close() {
        this.dialogRef.close()
    }
}
